import { render, staticRenderFns } from "./editCollege.vue?vue&type=template&id=1c95dbc4&scoped=true&"
import script from "./editCollege.vue?vue&type=script&lang=js&"
export * from "./editCollege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c95dbc4",
  null
  
)

export default component.exports